var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main-layout",
    [
      _c("section", { staticClass: "form" }, [
        _c(
          "div",
          { staticClass: "form-container", attrs: { id: "account" } },
          [
            _vm.pageInfo.loading
              ? _c("div", { staticClass: "loader" }, [
                  _c("div", { staticClass: "spinner" }, [
                    _c("div", { staticClass: "double-bounce1" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "double-bounce2" })
                  ]),
                  _vm._v(" "),
                  _c("h2", [_vm._v("please wait ..")])
                ])
              : !_vm.isRegisterFlow && !_vm.inviteKey
                ? _c("div", { staticClass: "notice" }, [
                    _c("h2", [_c("b", [_vm._v("Welcome!")])]),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "route-link",
                            attrs: { to: "/register-gdpr" }
                          },
                          [_vm._v("Invite company")]
                        ),
                        _vm._v(" or\n                  "),
                        _c(
                          "router-link",
                          {
                            staticClass: "route-link",
                            attrs: { to: "/download-direct" }
                          },
                          [_vm._v("Download DataMapper")]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
            _vm._v(" "),
            _vm.shouldShowPopup
              ? _c("signup-error", { on: { hide: _vm.togglePopup } })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isRegisterFlow && _vm.inviteKey && !_vm.pageInfo.loading
              ? _c("div", [
                  _vm.progress.value < 100
                    ? _c("div", { staticClass: "grid head" }, [
                        _c("div", { staticClass: "unit w-1-2" }, [
                          _c(
                            "h3",
                            [
                              _vm._v(_vm._s(_vm.pageInfo.title) + " "),
                              _vm.pageInfo.titleTooltip
                                ? _c("custom-tooltip", {
                                    attrs: {
                                      tooltipText: _vm.pageInfo.titleTooltip
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "unit w-1-2 breadcrumb" }, [
                          _c(
                            "span",
                            {
                              staticClass: "link",
                              class: {
                                active: _vm.process == "account",
                                done: _vm.done("account")
                              }
                            },
                            [
                              _c("i", { staticClass: "icon-check" }),
                              _vm._v(" Account\n                        ")
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isGDPRAdmin
                            ? _c("span", [
                                _c("span", { staticClass: "divider" }, [
                                  _vm._v("/")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "link",
                                    class: {
                                      active: _vm.process == "names",
                                      done: _vm.done("names")
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "icon-check" }),
                                    _vm._v(
                                      " Add names\n                            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "divider" }, [
                                  _vm._v("/")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "link",
                                    class: {
                                      active: _vm.process == "gdpr-invites",
                                      done: _vm.done("gdpr-invites")
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "icon-check" }),
                                    _vm._v(
                                      " Invite colleagues\n                            "
                                    )
                                  ]
                                )
                              ])
                            : _vm.isAdmin
                              ? _c("span", [
                                  _c("span", { staticClass: "divider" }, [
                                    _vm._v("/")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "link",
                                      class: {
                                        active: _vm.process == "groups",
                                        done: _vm.done("groups")
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "icon-check" }),
                                      _vm._v(
                                        " User Groups\n                            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "divider" }, [
                                    _vm._v("/")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "link",
                                      class: {
                                        active: _vm.process == "team",
                                        done: _vm.done("team")
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "icon-check" }),
                                      _vm._v(
                                        " Team\n                            "
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.progress.value < 100 && !_vm.isRegisterFlow
                    ? _c("div", { staticClass: "progress" }, [
                        _c("div", {
                          staticClass: "bar",
                          style: { width: _vm.progress.value * 100 + "%" }
                        })
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("router-view", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    (_vm.isRegisterFlow || _vm.inviteKey) &&
                    !_vm.pageInfo.loading,
                  expression:
                    "(isRegisterFlow || inviteKey) && !pageInfo.loading"
                }
              ]
            }),
            _vm._v(" "),
            _vm.pageInfo.error
              ? _c("p", { staticClass: "error" }, [
                  _vm._v(_vm._s(_vm.pageInfo.error))
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("signup-modal")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a926d90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a926d90","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./apps/account/App.vue
// module id = 570
// module chunks = 0